module.exports = __webpack_public_path__ + "media/images/beauty-uber-e4293cd1d80011f78f13012368858e73.png";